import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ContentField extends Vue {
    @Prop({default: ''}) label!: string;
}
